<template>
  <a-modal
    :title="status == 1 ? '详情' : '编辑'"
    style="top: 20px"
    :width="800"
    v-model="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    :cancelButtonProps="{ props: { disabled: true } }"
    :maskClosable="false"
    :footer="null"
  >
    <a-form :form="form" :class="status == 1 ? 'readyOnly' : ''">
      <a-form-item style="display: none">
        <a-input v-decorator="['channelId']" />
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品类别">
        <a-select v-decorator="['installType', { rules: [{ required: true, message: '请选择产品类别' }] }]">
          <a-select-option v-for="type in restaurantTypes" :key="type.code">{{ type.label }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业名称">
        <!--<a-input v-decorator="['enterpriseName', {rules: [{ required: true, message: '请输入企业名称'}]}]"/>-->
        <a-select
          showSearch
          optionFilterProp="children"
          @change="handleChange"
          :filterOption="filterOption"
          v-decorator="['enterpriseId', { rules: [{ required: true, message: '请选择企业名称' }] }]"
          :disabled="istrue"
        >
          <a-select-option v-for="item of data" :key="item.enterpriseId" :value="item.enterpriseId">{{
            item.enterpriseName
          }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="购买渠道名称">
        <a-input v-decorator="['channelName', { rules: [{ required: true, message: '请输入购买渠道名称' }] }]" />
      </a-form-item>
    </a-form>
    <a-row :class="status == 1 ? 'readyOnly' : ''" v-if="status != 1">
      <a-col :span="8" :offset="10">
        <!--<a-button @click="handleContinueSubmit()" v-if="brand == 1">保存并继续添加</a-button>-->
        <a-button style="margin-right: 8px" type="primary" @click="handleSubmit">保存</a-button>
        <a-button @click="showModal">取消</a-button>
      </a-col>
    </a-row>
  </a-modal>
</template>
<script>
import { saveChannel, getSlectCombox } from '@/api/enterprise/channel'
// import { getDictionary } from '@/api/workflow/dictionaries'
import pick from 'lodash.pick'
import { getDictMap } from '../../../utils/dict'
// import { getMap } from '../../../api/workflow/process'
export default {
  name: 'BrandModal',
  props: {},
  components: {},
  data() {
    return {
      queryParam: {},
      visible: false,
      restaurantOperTypeMap: {},
      restaurantTypes: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      mdl: {},
      form: this.$form.createForm(this),
      brand: 0,
      data: [],
      enterId: '',
      istrue: false,
      status: 0,
    }
  },
  beforeCreate() {},
  async created() {
    this.restaurantTypes = []
    this.restaurantOperTypeMap = await getDictMap('install_type')
    this.restaurantOperTypeMap.forEach((value, key) => {
      // console.log(value,key)
      this.restaurantTypes.push({ code: key, label: value })
    })
    // isAuthority: 1 数据隔离
    getSlectCombox({ isAuthority: 1 }).then((res) => {
      // console.log(res.data)
      this.data = res.data
    })
  },
  // created () {
  //   getMap({ 'dictType': 'install_type' }).then(res => {
  //     this.restaurantTypes = res
  //     console.log('dsadsadasda     ' + this.restaurantTypes)
  //     console.log('rows     ' + res)
  //   })
  // },
  // async  created () {
  //   // getDictionary('install_type').then(res =>{
  //   //   this.getDictionaryList = res.rows;
  //   // })
  //   // this.restaurantOperTypeMap = [];
  //   var result = await getDictionary('install_type');
  //   var restaurantOperTypeArray = result.rows

  //   restaurantOperTypeArray = restaurantOperTypeArray.filter(item => {
  //     //this.restaurantTypes.push({ code: key, label: value })
  //     return item.dictType === 'install_type'
  //   });
  //
  //   restaurantOperTypeArray.forEach(item => {{
  //     this.restaurantTypes.push({ code: item.dictValue, label: item.dictLabel })
  //   }})
  // },
  mounted() {},
  methods: {
    showModal() {
      this.visible = !this.visible
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    handleChange(value) {
      // console.log(`selected ${value}`)
      this.queryParam.enterpriseId = value
    },
    add(enterId) {
      this.enterId = enterId
      this.form.resetFields()
      this.edit({ channelId: 0 })
      this.brand = 1
    },
    edit(record, status) {
      this.status = status
      this.mdl = Object.assign(record)
      // console.log(record,this.enterId)
      this.visible = true
      if (this.enterId != '') {
        this.$nextTick(() => {
          this.form.setFieldsValue({ channelId: this.mdl.channelId, enterpriseId: this.enterId })
          this.istrue = true
        })
      } else {
        this.$nextTick(() => {
          this.form.setFieldsValue(
            pick(this.mdl, 'channelId', 'enterpriseId', 'installType', 'channelName', 'enterpriseName')
          )
        })
      }
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          this.confirmLoading = true
          saveChannel(values)
            .then((res) => {
              // console.log(values)
              if (res.code === 0) {
                this.$message.success('保存成功')
                if (values.channelId == 0) {
                  this.$emit('ok', 1)
                } else {
                  this.$emit('ok', 2)
                }
                this.visible = false
              } else {
                this.$message.success(res.msg)
              }
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
    },
  },
  // async handleRestaurantTypeChange (value) {
  //   // 查询对应属性的
  //   this.restaurantLists = []
  //   this.queryParam.type = value
  //   console.log('哈哈' + value)
  //   let arr = []
  //   await getBrandList(this.queryParam).then(function (result) {
  //     arr = result.rows
  //   })
  //   this.restaurantLists = arr
  // },
  watch: {
    /*
        'selectedRows': function (selectedRows) {
          this.needTotalList = this.needTotalList.map(item => {
            return {
              ...item,
              total: selectedRows.reduce( (sum, val) => {
                return sum + val[item.dataIndex]
              }, 0)
            }
          })
        }
        */
  },
}
</script>
<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  padding: 4px 16px !important;
}
.readyOnly {
  pointer-events: none;
}
</style>
